import { compose } from 'redux';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getCompany } from "../../actions/auth";
import { createRequest, getForms } from '../../actions/index';

import PageRedirect from './PageRedirect';

function mapStateToProps(state) {
  return {
    user: state.forms.user,
    companies: state.forms.companies,
    orn: state.forms.orn,
    forms: state.forms.forms,
  };
}

export const mapDispatchToProps  = {
  getCompany,
  getForms,
  createRequest,
};

export default compose(
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps)
)(PageRedirect);
